module.exports = __webpack_public_path__ + "images/emoji/gift_heart.773a9609e8c47ca2cc26.png";